import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

const PAWNSHOP_FORM_MODAL = 'PawnshopAddModal'

const PawnshopFormModal = Loadable(() => import('./PawnshopForm'))

export const createPawnshopNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'googles_yellow',
  text: translateFn('mnu_lmb_wizard'),
  identity: PAWNSHOP_FORM_MODAL,
  permission: 'LMB_WIZARD',
  component: PawnshopFormModal,
}))
